// extracted by mini-css-extract-plugin
export default {"contain":"Cards_contain__J8UKt","divStyles":"Cards_divStyles__PNQh6","logo2":"Cards_logo2__mEdX-","glow":"Cards_glow__7QqHJ"};